import { useEffect, useRef } from 'react';
import { useAjustes } from '../cms/ajustes';
import { urlImagen } from '../cms/sanity';

// awna.cl redirige a www: la canónica tiene que ser la dirección final
const SITIO = 'https://www.awna.cl';
const DESCRIPCION = 'Consultora de transformación digital y marketing en Chile: estrategia, marketing digital, marca, desarrollo web y customer experience con un solo equipo.';
const IMAGEN = `${SITIO}/og-awna.jpg`;

function meta(atributo, clave, contenido) {
    let tag = document.head.querySelector(`meta[${atributo}="${clave}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(atributo, clave);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', contenido);
}

function canonica(url) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
    }
    link.href = url;
}

/**
 * Título, descripción e imagen de la página para Google y para compartir.
 * Cada campo vale lo que el equipo puso en "Google y redes" (`seo`, de Sanity);
 * si está vacío, lo que pasa la página (título, resumen, portada); y al final,
 * lo del sitio en Ajustes. `titulo` vacío = la home ("Awna — …").
 *
 * Los crawlers de WhatsApp y LinkedIn no corren JavaScript: ven las etiquetas
 * por defecto de public/index.html. Google sí las lee.
 */
export default function useSeo({ titulo, descripcion, imagen, seo } = {}) {
    const ajustes = useAjustes().seo;
    // Con AnimatePresence la página que sale sigue montada un momento y ya ve la
    // dirección nueva: solo escribe la página que se montó en esta dirección
    const ruta = useRef(window.location.pathname);

    const tituloFinal = seo?.titulo || titulo;
    const textoTitulo = tituloFinal ? `${tituloFinal} | Awna` : `Awna — ${ajustes.titulo || 'Consultora de transformación digital y marketing'}`;
    const textoDescripcion = seo?.descripcion || descripcion || ajustes.descripcion || DESCRIPCION;
    const fuenteImagen = seo?.imagen?.asset ? seo.imagen : imagen || ajustes.imagen;
    const urlDeImagen = fuenteImagen ? new URL(urlImagen(fuenteImagen, { ancho: 1200, alto: 630 }), SITIO).href : IMAGEN;

    useEffect(() => {
        if (window.location.pathname !== ruta.current) return;
        const url = `${SITIO}${ruta.current === '/' ? '' : ruta.current}`;
        document.title = textoTitulo;
        meta('name', 'description', textoDescripcion);
        meta('property', 'og:title', textoTitulo);
        meta('property', 'og:description', textoDescripcion);
        meta('property', 'og:image', urlDeImagen);
        meta('property', 'og:url', url);
        meta('name', 'twitter:card', 'summary_large_image');
        canonica(url);
    }, [textoTitulo, textoDescripcion, urlDeImagen]);
}
